import { h } from 'preact';
import useFormStore from '../../store/useFormStore';

export default function WisetackBannerBlock() {
  const currentFranchise = useFormStore((state) => state.currentFranchise);
  const cart = useFormStore((state) => state.cart);

  // Don't render if no franchise or no wisetack link
  if (!currentFranchise?.wisetack_link) {
    return null;
  }

  // Only show if cart total is $500 or more
  const cartTotal = cart.total || 0;
  if (cartTotal < 500) {
    return null;
  }

  return (
    <div className="wisetack-banner-block bg-[#156ed7] rounded-lg p-6 text-center text-white shadow-sm">
      <div className="mb-6">
        <img
          src="https://cdn.prod.website-files.com/5f194315e6b47c1697925302/63ff658aae810ab61d7481f4_logo%20(1).svg"
          loading="lazy"
          alt="Wisetack Financing"
          className="h-12 mx-auto"
        />
      </div>

      <div className="text-4xl font-bold mb-6">
        NEW! We Offer Financing.
      </div>

      <p className="max-w-2xl mx-auto">
        <a
          href={currentFranchise.wisetack_link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white underline hover:no-underline font-semibold"
        >Prequalify today
        </a> and contact us to learn more about financing your next project!
      </p>
    </div>
  );
}
